import React from 'react';
import styled, { css } from 'styled-components';
import { PropTypes } from 'prop-types';
import ReactModal from 'react-modal';
import { FormattedMessage } from 'react-intl';
import { Button } from '../button';

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ customContainerStyle }) => css`
    ${customContainerStyle}
  `};
`;

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal || false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.showModal !== nextProps.showModal) {
      this.setState({ showModal: nextProps.showModal });
    }
  }

  handleOpenModal = () => {
    const { onOpen } = this.props;
    onOpen();
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    const { onClose } = this.props;
    onClose();
    this.setState({ showModal: false });
  };

  render() {
    const {
      content,
      customContainerStyle,
      customContentStyle,
      customOverlayStyle,
      fullWidth,
      hideButton,
      label,
      hideLaunchButton,
      closeButtonProps,
      launchButtonProps,
      modalProps,
    } = this.props;

    const modalStyle = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        ...customContentStyle,
      },
      overlay: {
        ...customOverlayStyle,
      },
    };

    return (
      <>
        <ReactModal
          isOpen={this.state.showModal}
          contentLabel="Modal Test"
          style={modalStyle}
          onRequestClose={this.handleCloseModal}
          shouldCloseOnOverlayClick
          shouldCloseOnEsc
          close
          {...modalProps}
        >
          <ModalContainer customContainerStyle={customContainerStyle}>
            {content}
            {!hideButton && (
              <Button
                onClick={this.handleCloseModal}
                content={<FormattedMessage id="Button.Close" />}
                {...closeButtonProps}
              />
            )}
          </ModalContainer>
        </ReactModal>
        {!hideLaunchButton && (
          <Button
            onClick={this.handleOpenModal}
            content={<FormattedMessage id={label} />}
            fullWidth={fullWidth}
            {...launchButtonProps}
          />
        )}
      </>
    );
  }
}

Modal.propTypes = {
  content: PropTypes.object,
  customContainerStyle: PropTypes.object,
  customContentStyle: PropTypes.object,
  customOverlayStyle: PropTypes.object,
  fullWidth: PropTypes.bool,
  hideButton: PropTypes.bool,
  label: PropTypes.string,
  hideLaunchButton: PropTypes.bool,
  showModal: PropTypes.bool,
  closeButtonProps: PropTypes.object,
  launchButtonProps: PropTypes.object,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  modalProps: PropTypes.object,
};

Modal.defaultProps = {
  content: null,
  label: 'Button.Open',
  customContainerStyle: {},
  customContentStyle: {},
  customOverlayStyle: {},
  fullWidth: false,
  hideButton: false,
  hideLaunchButton: false,
  showModal: false,
  closeButtonProps: {},
  launchButtonProps: {},
  onClose: () => null,
  onOpen: () => null,
  modalProps: {},
};

export default Modal;
